import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from '@pacifico/services/local/alert.service';
import { TypeAlert } from '@pacifico/types/types-model-components';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnDestroy, OnInit {
	@Input() title = '';
	@Input() message = '';
	@Input() showCloseButton = false;
	@Input() type: TypeAlert = 'warn';
	@Input() extraContent: string | undefined;
	@Input() isSnackBar = false;
	showComponent = true;
	showSnackBar = false;

	private _subscription!: Subscription;

	constructor(private alertService: AlertService) {}

	ngOnInit(): void {
		this._configSnackBar();
	}

	ngOnDestroy(): void {
		if (this.isSnackBar) {
			this._subscription.unsubscribe();
		}
	}

	clickClose(): void {
		if (!this.isSnackBar) {
			this.showComponent = false;
		}
	}

	getPathImage(): string {
		let nameImageAlert = 'alert_aviso.png';
		if (this.type === 'info') {
			nameImageAlert = 'alert_info.png';
		} else if (this.type === 'succes') {
			nameImageAlert = 'alert_exito.png';
		} else if (this.type === 'warn-ligth') {
			nameImageAlert = 'alert_advertencia.png';
		} else if (this.type === 'error') {
			nameImageAlert = 'alert_advertencia.png';
		}
		return `assets/images/${nameImageAlert}`;
	}

	private _configSnackBar(): void {
		if (this.isSnackBar) {
			this._subscription = this.alertService.$subject.subscribe((config) => {
				this.title = config.title;
				this.message = config.message;
				this.type = config.type;
				this.showSnackBar = true;
				setTimeout(() => {
					this.showSnackBar = false;
				}, 5000);
			});
		}
	}

	getBorder(): string {
		if (this.isSnackBar) {
			switch (this.type) {
				case 'info':
					return 'solid 2px #aecbff';
				case 'succes':
					return 'solid 2px #5acda2';
				case 'warn':
					return 'solid 2px #ffc75f';
				default:
					return 'solid 2px #ff9f9e';
			}
		}
		return '';
	}
}
